import * as React from 'react'

import {
  ResourceBulkEditButton,
  ResourceBulkEditPanel,
  ResourceCollapseToggle,
  ResourceColumnConfig,
  ResourceCreateButton,
  ResourceDeleteButton,
  ResourceDisplayOptions,
  ResourceEditPanel,
  ResourceExportButton,
  ResourceFilters,
  ResourceImportButton,
  ResourceRecordCount,
  ResourceSavedViews,
  ResourceSearch,
  ResourceTable,
} from './compound'

interface LayoutProps {
  children: React.ReactNode
  className?: string
}

const TopBar: React.FC<LayoutProps> = ({ children, className = '' }) => (
  <div
    className={`tw:flex tw:items-center tw:justify-between tw:w-full tw:px-4 tw:h-[55px] tw:border-0 tw:border-b tw:border-solid tw:border-border ${className}`}
  >
    {children}
  </div>
)

const Header: React.FC<LayoutProps> = ({ children, className = '' }) => (
  <div
    className={`tw:relative tw:z-20 tw:flex tw:items-center tw:overflow-visible tw:py-2 tw:px-4 tw:border-0 tw:border-b tw:border-solid tw:border-border ${className}`}
  >
    {children}
  </div>
)

const Actions: React.FC<LayoutProps> = ({ children }) => (
  <div className="tw:flex tw:items-center tw:gap-2 tw:ml-auto tw:pl-4">
    {children}
  </div>
)

const Content: React.FC<LayoutProps> = ({ children }) => (
  <div className="multi-grid-container tw:relative tw:overflow-hidden tw:flex tw:flex-col tw:h-full">
    {children}
  </div>
)

const ActionBar: React.FC<LayoutProps> = ({ children }) => (
  <div className="tw:flex tw:items-center tw:gap-2 tw:justify-between tw:py-1.5 tw:pr-4 tw:text-body-md tw:text-foreground">
    {children}
  </div>
)

const Separator: React.FC = () => (
  <div className="tw:mx-2.5 tw:grow-0 tw:border-0 tw:border-l tw:border-solid tw:border-border tw:h-7 tw:self-center" />
)

export const Resource = {
  TopBar,
  Header,
  Actions,
  Content,
  ActionBar,
  Separator,

  Search: ResourceSearch,
  Filters: ResourceFilters,
  SavedViews: ResourceSavedViews,

  CreateButton: ResourceCreateButton,
  BulkEditButton: ResourceBulkEditButton,
  ImportButton: ResourceImportButton,
  ExportButton: ResourceExportButton,

  CollapseToggle: ResourceCollapseToggle,
  RecordCount: ResourceRecordCount,
  DeleteButton: ResourceDeleteButton,
  ColumnConfig: ResourceColumnConfig,
  DisplayOptions: ResourceDisplayOptions,

  Table: ResourceTable,
  BulkEditPanel: ResourceBulkEditPanel,
  EditPanel: ResourceEditPanel,
}
